import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/base/Seo";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Missions from "./components/Missions";
import WhySupport from "./components/WhySupport";
import CallToAction from "./components/CallToAction";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "NGO",
  name: "Humanity59",
  alternateName: "Association Humanity59",
  url: "https://humanity59.com",
  description:
    "Association humanitaire internationale basée à Lille, qui agit en Afrique et en Asie : aide alimentaire, collectes, dons et bénévolat.",
  email: "contact@humanity59.com",
  telephone: "+33618232163",
  address: {
    "@type": "PostalAddress",
    streetAddress: "12 rue de la Solidarité",
    addressLocality: "Lille",
    postalCode: "59000",
    addressRegion: "Hauts-de-France",
    addressCountry: "FR",
  },
  sameAs: [
    "https://www.instagram.com/humanity59_",
    "https://www.snapchat.com/@faz-humanity59",
    "https://youtube.com/@humanity-59",
    "https://t.me/+3-x6F0OLfGg5MjM0",
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Seo
        title="Humanity59 | Association humanitaire internationale à Lille"
        description="Association humanitaire basée à Lille, Humanity59 agit en Afrique et en Asie : aide alimentaire, collectes, dons et bénévolat. Rejoignez nos actions solidaires."
        keywords="association humanitaire, aide alimentaire, solidarité, dons, bénévolat"
        path="/"
        jsonLd={organizationJsonLd}
      />
      <Header />
      <main className="flex-1">
        <Hero />
        <Stats />
        <Missions />
        <WhySupport />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}